import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-tab-selection',
  templateUrl: './tab-selection.component.html',
  styleUrls: ['./tab-selection.component.scss'],
  standalone: false
})
export class TabSelectionComponent implements OnInit, OnChanges {
  @Input() defaultSelection: string;
  @Input() tabNames: string[];
  @Input() distributionTabSelection: boolean;
  @Input() allocationTabSelection: boolean;
  @Input() showBorder: boolean;
  @Input() disabled: boolean;
  @Input() displayFn: (text: string) => string;
  @Input() disableAutomaticSelection?: boolean;

  @Output() changeSelectionTab = new EventEmitter<string>();

  public selectedTab: string;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.defaultSelection) {
      this.selectedTab = changes.defaultSelection?.currentValue || this.tabNames[0];
    }
  }

  ngOnInit(): void {
    this.selectedTab = this.defaultSelection ? this.defaultSelection : this.tabNames?.[0];
  }

  public changeSelection(tab: string): void {
    if (this.selectedTab === tab) {
      return;
    }

    if (this.disableAutomaticSelection) {
      this.changeSelectionTab.emit(tab);
    } else {
      this.selectedTab = tab;
      this.changeSelectionTab.emit(this.selectedTab);
    }
  }

  public displayText(text: string): string {
    return this.displayFn ? this.displayFn(text) : text;
  }
}
